'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _giftCardsTray = require('./gift-cards-tray');

var _giftCardsTray2 = _interopRequireDefault(_giftCardsTray);

var _giftCardsList = require('./gift-cards-list');

var _giftCardsList2 = _interopRequireDefault(_giftCardsList);

var _purchase = require('./purchase');

var _purchase2 = _interopRequireDefault(_purchase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import Content from '../content/content';


//import GiftCardContents from './gift-cards-content';
//import ShowbagBackground from './showbag-background';
//import CloseButton from './close-button';
//import GridSizer from './grid-sizer';

/** @class Showbag
  * This component displays content that visitors
  * have added to a personal "showbag".  It also
  * adds methods to a global `vexpo.showbag` object:
  * `vexpo.showbag.add(content)` adds a new content item
  * to the showbag.  Returns a promise.
  * `vexpo.showbag.remove(content)` similarily removes
  * the specified content from the showbag.  Returns a
  * promise.
  * `vexpo.showbag.includes(content)` returns true if the
  * content exists in the showbag, or false otherwise
  * `vexpo.showbag.show()` displays the showbag.
  * @prop {URLString} background - an (optional) image to display
  * behind the showbag contents.
  * @prop {Array} initialContents - an (optional) array of contents
  * to preload into visitor's bags.
  */
var GiftCards = function (_Component) {
  _inherits(GiftCards, _Component);

  /** @constructor
    * Constructs a new GiftCard component, customized to the
    * current user (as defined by firebase auth).
    */
  function GiftCards(props) {
    _classCallCheck(this, GiftCards);

    var _this = _possibleConstructorReturn(this, (GiftCards.__proto__ || Object.getPrototypeOf(GiftCards)).call(this, props));

    _this.state = {
      visible: true,
      purchased: false,
      giftCards: []
    };
    _this.handleAuthStateChanged = _this.handleAuthStateChanged.bind(_this);
    _this.loadGiftCards = _this.loadGiftCards.bind(_this);
    _this.getExhibitorCards = _this.getExhibitorCards.bind(_this);
    return _this;
  }
  /** @method componentWillMount
    * Links the component with the user's gift
    * card data in the database and sets up the
    * `vepo.giftcards` functions.
    */


  _createClass(GiftCards, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Add gift cards to the vexpo object
      if (!window.vexpo) window.vexpo = {};
      if (!window.vexpo.giftCards) window.vexpo.giftCards = {};
      window.vexpo.giftCards.getExhibitorCards = this.getExhibitorCards;

      if (window.vexpo.firebase) {
        window.vexpo.firebase.auth().onAuthStateChanged(this.handleAuthStateChanged);
        if (window.vexpo.firebase.auth().currentUser) {
          var user = window.vexpo.firebase.auth().currentUser;
          this.loadGiftCards(user);
        }
      }
    }
    /** @method handleAuthStateChanged
      * Event handler triggered on an auth state
      * change; invokes loading of gift cards
      * (if purchased)
      * @param {firebase.User} user - the current user
      */

  }, {
    key: 'handleAuthStateChanged',
    value: function handleAuthStateChanged(user) {
      if (user) {
        this.loadGiftCards(user);
      } else {
        // If there is no logged-in user, there can't be
        // any gift cards
        this.setState({ purchased: false, giftCards: [] });
        return null;
      }
    }
    /** @method loadGiftCards
      * Loads the gift cards from the realtime database.
      * If the user has not made a purchase, the load fails.
      * @param {user} user - the user id
      */

  }, {
    key: 'loadGiftCards',
    value: function loadGiftCards(user) {
      var _this2 = this;

      // First, check if the user purchased gift cards
      window.vexpo.firebase.database().ref('giftCardPurchase/' + user.uid + '/' + this.props.expoID + '/' + this.props.showID).once('value').then(function (snapshot) {
        // User has purchased cards...
        window.vexpo.firebase.database().ref('expos/' + _this2.props.expoID + '/shows/' + _this2.props.showID + '/giftCards').once('value').then(function (snapshot) {
          _this2.setState({
            purchased: true,
            giftCards: Object.values(snapshot.val())
          });
          if (window.vexpo) window.vexpo.giftCards.purchased = true;
        });
      }).catch(function (error) {
        // most likely cause of error is lack of permission
        // to access the data (i.e. have not made a purchase)
        _this2.setState({
          purchased: false,
          giftCards: []
        });
        if (window.vexpo) window.vexpo.giftCards.purchased = false;
      });
    }
    /** @method getExhibitorCards
      * Returns the cards belonging to the specified exhibitor
      * @param {string} exhibitorID - the unique identifier of the exhibitor
      * @returns {array} an array of gift cards
      */

  }, {
    key: 'getExhibitorCards',
    value: function getExhibitorCards(exhibitorID) {
      return this.state.giftCards.filter(function (giftCard) {
        return giftCard.exhibitorID === exhibitorID;
      });
    }
    /** @method show
      * Displays the gift cards.
      */

  }, {
    key: 'show',
    value: function show() {
      this.setState({ visible: true });
    }
    /** @method exit
      * Hides the gift card display
      */

  }, {
    key: 'exit',
    value: function exit() {
      this.setState({ visible: false });
    }
    /** @method render
      * Renders the gift cards, if purchased, or a
      * purchase page if not.
      */

  }, {
    key: 'render',
    value: function render() {
      var content = void 0;
      if (this.state.purchased) {
        content = _react2.default.createElement(_giftCardsList2.default, { giftCards: this.state.giftCards, instructions: this.props.instructions });
      } else {
        content = _react2.default.createElement(_purchase2.default, _defineProperty({ expoID: this.props.expoID, showID: this.props.showID, name: this.props.name, supportEmail: this.props.supportEmail, image: this.props.image, video: this.props.video, exhibitors: this.props.exhibitors, deals: this.props.deals, beneficiaries: this.props.beneficiaries, logo: this.props.logo }, 'deals', this.props.deals));
      }
      return _react2.default.createElement(
        _giftCardsTray2.default,
        { background: this.props.background },
        content
      );
    }
  }]);

  return GiftCards;
}(_react.Component);

exports.default = GiftCards;


GiftCards.propTypes = {
  expoID: _propTypes2.default.string.isRequired,
  showID: _propTypes2.default.string.isRequired,
  deals: _propTypes2.default.array.isRequired,
  background: _propTypes2.default.string,
  instructions: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/gift-cards/gift-cards.js
// module id = 259
// module chunks = 0